'use client';

import { StyledTooltipContainer } from '@components/InternalIcons/Tooltip.styled';
import { openInternalPopup } from '@components/InternalIcons/utils/internalPopup';
import { Flex, freddyTheme, IconButton } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { Copy } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement } from 'react';

export default function VanessaClipboardIcon({
  url,
  index,
  totalIndices
}: {
  url: string;
  index: number;
  totalIndices: number;
}): ReactElement {
  const iconLabel = 'Vanessa: Add product to clipboard';
  const { trackEvent } = useAnalytics();

  return (
    <Flex alignItems='center' color={freddyTheme.color.icon.base}>
      <StyledTooltipContainer
        data-internal-icons-tooltip={iconLabel}
        data-testid='vanessa-clipboard-icon'
      >
        <IconButton
          size='small'
          onClick={() => {
            trackEvent(
              selectOptionTrigger({
                sub_feature: 'clipboard_vanessa',
                index: index,
                total_indices: totalIndices,
                selection_type: 'selected',
                option_name: 'clipboard_vanessa',
                attribute: 'clipboard_vanessa'
              })
            );
            openInternalPopup(url);
          }}
          sx={theme => ({
            padding: theme.spacing[200]
          })}
        >
          <Copy aria-label={iconLabel} />
        </IconButton>
      </StyledTooltipContainer>
    </Flex>
  );
}
